import { createStore } from "vuex";
import mainStore from "@/store/modules/main-store";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    mainStore,
  },
});
